import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';


export default class StudentAllRegisteredExamsTable extends React.Component {
    render() {
        const { data, gradedActivityTypes } = this.props;
        return (
            <Table tablet stackable celled selectable compact>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{<FormattedMessage id="common.courseName" />}</Table.HeaderCell>
                        <Table.HeaderCell>{<FormattedMessage id="professorInputGrades.examType" />}</Table.HeaderCell>
                        <Table.HeaderCell>{<FormattedMessage id="professorInputGrades.examDateDate" />}</Table.HeaderCell>
                        <Table.HeaderCell>{<FormattedMessage id="common.teacher" />}</Table.HeaderCell>
                        <Table.HeaderCell>{<FormattedMessage id="common.classroom" />}</Table.HeaderCell>
                        <Table.HeaderCell>{<FormattedMessage id="common.comment" />}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data.map(row => (
                        <Table.Row key={row.gradedActivityId}>
                            <Table.Cell verticalAlign="middle">{row.courseName}</Table.Cell>
                            <Table.Cell verticalAlign="middle">{row.gradedActivityType ? gradedActivityTypes.find(el => el.id === row.gradedActivityType).name : null}</Table.Cell>
                            <Table.Cell verticalAlign="middle">{row.examDate ? moment(row.examDate).format('D. M. YYYY. - HH:mm') : ''}</Table.Cell>
                            <Table.Cell verticalAlign="middle">{row.teacherName}</Table.Cell>
                            <Table.Cell verticalAlign="middle">{row.classroom}</Table.Cell>
                            <Table.Cell verticalAlign="middle">{row.comment}</Table.Cell>
                        </Table.Row>))}
                </Table.Body>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentRegisterExams/StudentAllRegisteredExamsTable.js